import { CertStateReview } from './api/certification';

/**
 * SW2-2248 (Matt's Oct 9 comment) — the review email's Approve / Reject buttons open
 * `/inspection/:id?review=approve` or `?review=reject`. Neither acts by itself: approve brings the
 * Report Reviewer line into view, ready to sign; reject opens the reject dialog (a reason is
 * required). Only for the resolved reviewer of a pending review, which the server decides
 * (`review.canSign`); anyone else just sees the inspection.
 */
export type ReviewDeepLink = 'approve' | 'reject';

/** The `review` query parameter, when it is one this page acts on. */
export function readReviewDeepLink(search: string): ReviewDeepLink | null {
  const value = new URLSearchParams(search).get('review');

  return value === 'approve' || value === 'reject' ? value : null;
}

/** What to do with a deep link, given the inspection's review state. */
export function reviewDeepLinkAction(
  link: ReviewDeepLink | null,
  review: CertStateReview | null | undefined,
): ReviewDeepLink | 'ignore' | null {
  if (!link) return null;

  return review?.status === 'pending' && review.canSign ? link : 'ignore';
}
